import { render } from "./WorkEnvironment.vue?vue&type=template&id=72160eec"
import script from "./WorkEnvironment.vue?vue&type=script&lang=js"
export * from "./WorkEnvironment.vue?vue&type=script&lang=js"

import "./WorkEnvironment.vue?vue&type=style&index=0&id=72160eec&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__